"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LanguageEnvVariableProvider = /** @class */ (function () {
    function LanguageEnvVariableProvider() {
    }
    /**
     * Obtains the conversation language from the property 'CONVERSATION_LANGUAGE'
     */
    LanguageEnvVariableProvider.prototype.get = function () {
        var conversationLanguage = process.env.CONVERSATION_LANGUAGE;
        console.log("Env variable CONVERSATION_LANGUAGE contains value: " + conversationLanguage);
        return conversationLanguage;
    };
    LanguageEnvVariableProvider.prototype.toString = function () {
        return "Class [" + LanguageEnvVariableProvider.name + "] with value: " + this.get();
    };
    return LanguageEnvVariableProvider;
}());
exports.LanguageEnvVariableProvider = LanguageEnvVariableProvider;
